import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css, CSSProperties} from 'styled-components'

export const StyledSwitchField = styled(Grid)<{$height?: CSSProperties['height']}>(
    ({$height = 'auto'}) => css`
        align-items: end;
        height: ${$height};
    `
)
